// services.jsx
import React from 'react';
import './services.css';
import Sidebar from '../sidebar/sidebar';

const Services = () => {
  return (
    <div className="home-container">
      <Sidebar />
      <div className="home-content">
        <img
          src="https://sssdemo-images.s3.ap-south-1.amazonaws.com/images/4.png" // Replace with your image URL
          alt="Services"
          className="home-image"
        />
      </div>
    </div>
  );
};

export default Services;
